import { MedicareBridgeCaseView } from './medicare-bridge.types';
import { MedicareBridgeHandoff } from './MedicareBridgeHandoff';
import { MedicareBridgeRequirements } from './MedicareBridgeRequirements';

export function MedicareBridgePrepStep({
  stepNumber,
  bridgeCase,
}: {
  stepNumber?: number;
  bridgeCase: MedicareBridgeCaseView;
}) {
  return (
    <section className="flex flex-col gap-2" data-testid="medicare-bridge-prep-step">
      <p className="text-xs font-semibold uppercase tracking-[0.5px] text-muted-foreground">
        {stepNumber != null
          ? `Step ${stepNumber}: Medicare Bridge`
          : 'Medicare Bridge'}
      </p>
      <MedicareBridgeRequirements bridgeCase={bridgeCase} />
      <MedicareBridgeHandoff checklist={bridgeCase.checklist} />
    </section>
  );
}
